// extracted by mini-css-extract-plugin
export default {"root":"TipStuList_root__AWaFU","overlay":"TipStuList_overlay__PYbsv","item":"TipStuList_item__s8d13","num":"TipStuList_num__43E9i"};